<!--  -->
<template>
  <div class="glossary-details">
    <div class="glossary-title" v-html="glossaryInfo.g_title">
      <!-- {{}} -->
    </div>
    <div class="glossary-details-info">
      <div class="glossary-general-info">
        <h3 class="general-info-title">General Info</h3>
        <div class="general-info-container">
          <dl>
            <dt>Term</dt>
            <dd v-html="glossaryInfo.g_title"></dd>
          </dl>
          <dl>
            <dt>Latin name</dt>
            <dd v-html="glossaryInfo.g_latin_title"></dd>
          </dl>
          <dl>
            <dt>Created time</dt>
            <dd>{{glossaryInfo.g_time}}</dd>
          </dl>
          <dl>
            <dt>Contributor</dt>
            <dd v-html="glossaryInfo.admin_en_name"></dd>
          </dl>
          <dl>
            <dt>Last edit time</dt>
            <dd v-html="glossaryInfo.g_last_edit_time"></dd>
          </dl>
          <dl>
            <dt>Related literature</dt>
            <dd v-html="glossaryInfo.r_doi"></dd>
          </dl>
          <dl>
            <dt>Contribution</dt>
            <dd>{{innerHTML(glossaryInfo.admin_en_name)}} add[{{innerHTML(glossaryInfo.g_time)}}]</dd>
          </dl>
        </div>
      </div>
      <div class="glossary-g-con">
        <div v-html="glossaryInfo.g_con"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { getGlossaryDetails } from "@/api/index";
import { mixins } from "@/mixins/index.js";
export default {
  mixins: [mixins],
  components: {},
  data() {
    return {
      glossaryInfo: {
        admin_en_name: "",
        admin_id: 0,
        admin_name: "",
        g_con: "",
        g_last_edit_time: "",
        g_latin_title: "",
        g_r_img: "",
        g_time: "",
        g_title: "",
        glossary_id: 0,
      },
    };
  },
  //生命周期 - 创建完成（访问当前this实例）
  created() {},
  //生命周期 - 挂载完成（访问DOM元素）
  mounted() {
    this.getGlossaryDetails(this.$route.params.glossary_id);
  },
  methods: {
    getGlossaryDetails(id) {
      getGlossaryDetails(id)
        .then((res) => {
          let data = res.data?.data;
          for (let key in this.glossaryInfo) {
            this.glossaryInfo[key] = data[key];
          }
        })
        .catch((e) => {
          console.log(e);
        });
    },
  },
};
</script>
<style >
.glossary-title {
  height: 143px;
  background: linear-gradient(90deg, #189ca9 9.4%, #72c2c9 93.4%);
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 40px;
  line-height: 130px;
  color: #ffffff;
  padding-left: 48px;
}
.glossary-details-info {
  display: flex;
  justify-content: space-around;
  align-content: center;
  width: 100%;
  padding: 32px 48px 60px;
  overflow: hidden;
}
.glossary-general-info {
  width: 64%;
  margin-right: 2%;
  background: #ffffff;
  border-radius: 4px;
  padding: 20px;
}
.glossary-g-con {
  width: 34%;
  max-width: 455px;
  padding: 20px;
  background: white;
}
.glossary-g-con span {
  color: #c4c4c4;
}
.general-info-title {
  font-family: Roboto;
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: 28px;
  color: #484d63;
  margin-bottom: 32px;
}
.general-info-container {
}
.general-info-container dl {
  line-height: 20px;
  padding: 12px 0;
  border-bottom: 2px solid #efefef;
  color: #484d63;
}
.general-info-container dl dt {
  width: 190px;
}
.general-info-container dd {
  display: inline-block;
  width: calc(100% - 190px);
}
.crumb-list {
  margin-bottom: 12px;
}
.crumb-list span {
  font-size: 16px;
  line-height: 18px;
  color: #c4c4c4;
}
.specimens-list div {
  margin-bottom: 12px;
}
.specimens-list a {
  font-size: 16px;
  line-height: 19px;

  color: #72c2c9;
}
</style>